export interface ImpersonationState {
  isImpersonating: boolean;
  permissions: string[];
}

export const initialImpersonationState: ImpersonationState = {
  isImpersonating: false,
  permissions: []
};
